<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PlayAndWin',
};
</script>
<style lang="scss" scoped></style>
